import * as modules from "./modules/";
import config from "../../../../config";

const { vendor } = config;

const MediaMonitorWrapper = modules[vendor]
  ? modules[vendor]
  : modules["default"];

export default MediaMonitorWrapper;
